<template>
  <v-container class="pt-0">
    <v-row
      ><v-col class="mx-0 px-0 pt-0">
        <header-text-bg :site="site" :text="title" />
      </v-col>
    </v-row>

    <v-row class="mx-2" style="display: flex; gap: 10px; margin-top: -30px">
      <!-- ALL -->
      <v-btn
        elevation="5"
        class="rounded-lg"
        @click="changeType('all')"
        :style="{
          flex: 1,
          backgroundColor: type === 'all' ? site.color : 'white',
          color: type === 'all' ? 'white' : 'black',
          textTransform: 'none',
          fontWeight: 500,
          justifyContent: 'center',
        }"
      >
        <!-- <v-icon
          left
          :style="{
            color: type === 'all' ? 'white' : site.color,
          }"
        >
          mdi-format-list-bulleted
        </v-icon> -->
        {{ $t("coinAll") }}
      </v-btn>

      <v-btn
        elevation="5"
        class="rounded-lg"
        @click="changeType('earn_point')"
        :style="{
          flex: 1,
          backgroundColor: type === 'earn_point' ? site.color : 'white',
          color: type === 'earn_point' ? 'white' : 'black',
          textTransform: 'none',
          fontWeight: 500,
          justifyContent: 'center',
        }"
      >
        <!-- <v-icon
          left
          :style="{
            color: type === 'earn_point' ? 'white' : site.color,
          }"
        >
          mdi-plus-circle-multiple-outline
        </v-icon> -->
        {{ $t("coinReceived") }}
      </v-btn>

      <v-btn
        elevation="5"
        class="rounded-lg"
        @click="changeType('use_point')"
        :style="{
          flex: 1,
          backgroundColor: type === 'use_point' ? site.color : 'white',
          color: type === 'use_point' ? 'white' : 'black',
          textTransform: 'none',
          fontWeight: 500,
          justifyContent: 'center',
        }"
      >
        <!-- <v-icon
          left
          :style="{
            color: type === 'use_point' ? 'white' : site.color,
          }"
        >
          mdi-minus-circle-multiple-outline
        </v-icon> -->
        {{ $t("coinUsed") }}
      </v-btn>
    </v-row>

    <v-row
      class="justify-center mt-5 mb-3 mx-2"
      style="background-color: #ffffff; border-radius: 8px"
    >
      <v-col cols="5" sm="5" md="4" class="px-0">
        <v-menu
          v-model="startDateMenu"
          :close-on-content-click="false"
          transition="scale-transition"
          offset-y
          min-width="auto"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              outlined
              dense
              v-model="from_date"
              :label="$t('startDate')"
              append-icon="mdi-calendar"
              readonly
              v-bind="attrs"
              v-on="on"
              hide-details
            ></v-text-field>
          </template>
          <v-date-picker
            :color="site.color"
            no-title
            scrollable
            v-model="from_date"
            @input="startDateMenu = false"
          ></v-date-picker>
        </v-menu>
      </v-col>
      <v-col cols="1" class="text-center px-0"
        ><p class="mb-0 mt-2">-</p>
      </v-col>
      <v-col cols="5" sm="5" md="4" class="px-0">
        <v-menu
          v-model="endDateMenu"
          :close-on-content-click="false"
          transition="scale-transition"
          offset-y
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              outlined
              dense
              v-model="to_date"
              :label="$t('endDate')"
              append-icon="mdi-calendar"
              readonly
              v-bind="attrs"
              v-on="on"
              hide-details
            ></v-text-field>
          </template>
          <v-date-picker
            :color="site.color"
            no-title
            scrollable
            v-model="to_date"
            @input="endDateMenu = false"
          ></v-date-picker>
        </v-menu>
      </v-col>
    </v-row>

    <v-row class="px-2">
      <v-col
        v-for="(item, index) in listData"
        :key="index"
        cols="12"
        class="py-1"
      >
        <v-sheet style="border-radius: 8px">
          <v-card
            elevation="0"
            :color="colorCard"
            style="border-radius: 8px"
            @click="handleOpenHistoryDetail(item)"
          >
            <v-card-title class="py-1 px-1">
              <v-container>
                <v-row>
                  <v-col cols="8">
                    <p class="text-body-2 text-truncate mb-0 font-weight-bold">
                      {{ item.description }}
                    </p>
                    <p class="text-caption mb-0">
                      {{ item.created_at | checkExpire }}
                    </p>
                    <p class="text-caption mb-0 mt-1" v-if="item.user">
                      <v-avatar
                        size="20"
                        class="mr-1"
                        style="background-color: black"
                      >
                        <v-img
                          :src="
                            item.user.image_path
                              ? item.user.image_path
                              : defaultImage
                          "
                        ></v-img>
                      </v-avatar>
                      <span class="mt-1" style="font-style: italic">
                        {{ item.user.name }} {{ item.user.surname }}
                      </span>
                    </p>
                  </v-col>
                  <v-col
                    cols="4"
                    class="px-0 pr-2 d-flex flex-column justify-center align-end"
                  >
                    <div class="d-flex align-center">
                      <p
                        class="text-body-1 mb-0"
                        style="font-weight: 600"
                        :style="{
                          color: item.point >= 0 ? site.color : 'red',
                        }"
                      >
                        {{
                          item.point > 0
                            ? `+${abbreviateNumber(item.point)} `
                            : `${abbreviateNumber(item.point)} `
                        }}
                        <!-- check code == transfer coin -->
                      </p>
                      <div class="ml-1">
                        <PointSymbol
                          :type="item.point_type_type"
                          :symbol="item.point_type_symbol"
                          :color="item.point_type_color"
                          :is_display="true"
                          :outlined_box="false"
                          :size="28"
                        />
                      </div>
                    </div>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-title>
          </v-card>
        </v-sheet>
      </v-col>
    </v-row>

    <div v-if="!listData.length">
      <v-col class="d-flex justify-center mt-16">
        <v-img
          class="white--text mx-auto mt-10 empty"
          :src="require('@/assets/images/out-of-stock.png')"
          max-width="150px"
        >
        </v-img>
      </v-col>
      <p class="text-center">{{ $t("errDataNotFound") }}</p>
    </div>

    <v-dialog v-model="dialogOpen" max-width="400">
      <v-card>
        <v-card-title class="pa-0">
          <div class="d-flex justify-end" style="width: 100%">
            <v-btn icon @click="dialogOpen = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </div>
        </v-card-title>
        <v-card-text class="pb-6">
          <div>
            <div class="d-flex">
              <div style="text-align: left; font-weight: 700">
                {{ $t("date") }}
              </div>
              <div style="margin-left: 4px">
                {{ itemSelected.created_at | formatDate }}
              </div>
            </div>
            <div class="d-flex align-center" style="width: 100%">
              <div
                style="text-align: left; font-weight: 700; margin-right: 8px"
              >
                {{ $t("amount") }}
              </div>
              <div
                style="
                  max-width: calc(100% - 48px);
                  width: fit-content;
                  padding: 4px 12px;
                  border-radius: 16px;
                  color: #000000;
                  display: flex;
                "
                :style="{
                  'background-color':
                    itemSelected.point > 0 ? '#C8E6C9' : '#FFCDD2',
                }"
              >
                <div class="d-flex align-center" style="width: 100%; gap: 4px">
                  <PointSymbol
                    :type="itemSelected.point_type_type"
                    :symbol="itemSelected.point_type_symbol"
                    :color="itemSelected.point_type_color"
                    :is_display="true"
                    :outlined_box="false"
                    :size="20"
                  />
                  {{ itemSelected.point | commaPoint }}
                  <div class="text-truncate">
                    {{ itemSelected.point_type_name }}
                  </div>
                </div>
              </div>
            </div>
            <div>
              <div style="text-align: left; font-weight: 700">
                {{ $t("message") }}
              </div>
              <div style="text-align: left; white-space: pre-line">
                {{ itemSelected.description || "" }}
              </div>
            </div>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { mapState } from "vuex";
import headerTextBg from "@/components/headerTextBg.vue";
import Axios from "@/config/customer-service";
import moment from "moment";
import { blendColorWithWhite } from "../../../config/general-function";
import PointSymbol from "../../../components/point/point-symbol.vue";

export default {
  inject: ["isAppLoading"],
  components: {
    headerTextBg,
    PointSymbol,
  },

  data() {
    return {
      drawer: false,
      type: "all",
      from_date: new Date(
        new Date().setDate(new Date().getDate() - 30) -
          new Date().getTimezoneOffset() * 60000
      )
        .toISOString()
        .substr(0, 10),
      to_date: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10),
      listData: [],
      startDateMenu: false,
      endDateMenu: false,
      title: "",

      dialogOpen: false,
      itemSelected: {},
    };
  },
  created() {
    const menu = JSON.parse(this.site.menu_account);
    const model = menu?.find((x) => x.to == "my-history");
    this.title = model?.name;
  },

  computed: {
    ...mapState("defaultSystem", ["site"]),
    colorCard() {
      let themeColor = this.site.color || "#f2c00e";
      themeColor = blendColorWithWhite(themeColor, 0.2);
      return themeColor;
    },
    defaultImage() {
      return require("@/assets/images/user.svg");
    },
  },
  beforeMount() {
    this.getHistory("all");
  },

  methods: {
    getHistory(type = this.type) {
      this.isAppLoading(true);
      this.listData = [];
      this.type = type;
      Axios.get(
        `point/getHistoryPoint?type=${this.type}&from_date=${this.from_date}&to_date=${this.to_date}`
      )
        .then(({ data }) => {
          if (data.status == "success") {
            this.listData = data.data.data;
          }
        })
        .catch(() => {
          const targetRoute = this.$router.resolve({
            name: "main",
          });
          window.location.href = targetRoute.href;
        })
        .finally(() => {
          this.isAppLoading(false);
        });
    },
    abbreviateNumber(value) {
      if (!value) return "0";
      let number = Intl.NumberFormat("en-US", {
        notation: "compact",
        maximumFractionDigits: 1,
      }).format(value);
      return number;
    },
    changeType(newType) {
      if (this.type === newType) return;
      this.type = newType;
      this.getHistory(newType);
    },
    handleOpenHistoryDetail(param) {
      this.itemSelected = { ...param };
      this.dialogOpen = true;
    },
  },
  watch: {
    to_date: {
      handler() {
        this.getHistory();
      },
      deep: true,
    },
    from_date: {
      handler() {
        this.getHistory();
      },
      deep: true,
    },
  },
  filters: {
    checkExpire(value) {
      if (!value) return "-";
      const date = moment(value);
      let label = "";
      if (date.year() == moment().year()) {
        label = date.format("DD MMM, HH:mm");
      } else {
        label = date.format("DD MMM YY, HH:mm");
      }
      return label;
    },
    formatDate: function (value) {
      if (!value) return "-";
      const date = moment(value);
      let label = "";
      if (date.year() == moment().year()) {
        label = date.format("DD MMM, HH:mm");
      } else {
        label = date.format("DD MMM YY, HH:mm");
      }
      return label;
    },
    commaPoint(value) {
      // comma point number to baht
      if (value == 0) {
        return "0";
      } else if (value) {
        return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      }
    },
  },
};
</script>

<style scoped>
</style>
